import { render, staticRenderFns } from "./UtmLabel.vue?vue&type=template&id=67a9ece6&scoped=true"
import script from "./UtmLabel.vue?vue&type=script&lang=js"
export * from "./UtmLabel.vue?vue&type=script&lang=js"
import style0 from "./UtmLabel.vue?vue&type=style&index=0&id=67a9ece6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a9ece6",
  null
  
)

export default component.exports